export type Intent = 'compliment' | 'complaint'

export interface ContactOption {
  id: string
  label: string
}

export const COMPLIMENTS: ContactOption[] = [
  { id: 'c1', label: 'Your website loaded.' },
  { id: 'c2', label: 'I appreciate that this form exists.' },
  { id: 'c3', label: 'You seem like a real company.' },
  { id: 'c4', label: 'The colors are colors.' },
  { id: 'c5', label: 'Nice favicon (presumably).' },
  { id: 'c6', label: 'You have a contact page, which is more than some.' },
]

export const COMPLAINTS: ContactOption[] = [
  { id: 'x1', label: 'It could be better.' },
  { id: 'x2', label: 'I expected more.' },
  {
    id: 'x3',
    label: 'This is not what I wanted, though I cannot specify what I wanted.',
  },
  { id: 'x4', label: 'Something is wrong somewhere.' },
  { id: 'x5', label: 'I am vaguely dissatisfied.' },
  { id: 'x6', label: 'The vibe is off.' },
]

export const DEPARTMENTS = [
  'Wherever',
  'Not Sure',
  'The Void',
  'Reception (Closed)',
] as const

export const URGENCIES = [
  'Whenever',
  'Eventually',
  'No Rush',
  'Also Whenever',
] as const
